import { IComponentOptions } from 'angular';
import nvSdcModule from '../../../nv.sdcModule.module';
import { GridColumnEditCtrl } from './grid-column-editor.controller';

export const GridColumnEditorComponent: IComponentOptions = {
  template: require('./grid-column-editor.html'),
  controller: GridColumnEditCtrl,
  bindings: {
    cancel: '&',
    refreshColumns: '&',
  },
};

angular.module(nvSdcModule).component('nvGridColEditor', GridColumnEditorComponent);
